export const timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d$/
export const PASSWORD_REGEX = /^[A-z0-9!@#%]{8,20}$/
export const NAME_REGEX = /^(?=.{1,30}$)[a-zA-ZÄÖÕÜÆØÅäöõüæøå]+(?: [a-zA-ZÄÖÕÜÆØÅäöõüæøå]+)*$/
export const USERNAME_REGEX = /^[A-z0-9]{6,20}$/
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const NUMBER_INPUT_REGEX = /^(|0|[1-9]\d*)$/
export const DECIMAL_NUMBER_REGEX = /^(|0|[1-9]\d*)(\.\d{0,2})?$/
